import React from 'react';
import { Spinner } from '@cloudscape-design/components';
import './FullPageLoading.css';

const FullPageLoading = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <div className="loader-overlay">
      <div className="loader-spinner">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default FullPageLoading;
